import styled from "styled-components";
import { Button } from "discover.medical.react-component-library";

export const DrugInteractionsResultsContainer = styled.div`
  margin: ${({ theme }) => theme.space.xl} auto;
`;

export const DrugInteractionsSeverityIndexButton = styled(Button)`
  max-height: ${({ theme }) => theme.space.xl};
  font-size: ${({ theme }) => theme.font.size.sm};
`;
